export default "__VITE_ASSET__f4cd0085__"